import parse from 'html-react-parser';
import styles from './preview.module.scss';
import { wallexState } from '../../wallex.state';
import LeadMagnetsForm from '../../../../shared/forms/leadmagnet-form';
import { LeadMagnetStories } from '@models/leadmagnet.types';

const Preview = () => {
  const { preview: { title, description } } = wallexState;

  return (
    <section className={styles.section}>
      <div className={styles.section__content}>
        <h1 className={styles.section__title}>{parse(title)}</h1>
        {description.map((item: string, idx: number) => (
          <p key={idx} className={styles.section__text}>{item}</p>
        ))}
      </div>
      <div className={styles.section__form}>
        <LeadMagnetsForm story={LeadMagnetStories.Wallex}/>
      </div>
    </section>
  )
}

export default Preview;
